import React from 'react';
import styles from './LanguageToggle.module.css';
import { LANGUAGE_OPTIONS } from '../utils/bilingualResolver';

export default function LanguageToggle({ language, onChange }) {
  return (
    <div className={styles.languageToggle}>
      {LANGUAGE_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className={`${styles.languageButton} ${language === option.id ? styles.languageButtonActive : ''}`}
          onClick={() => onChange(option.id)}
          aria-pressed={language === option.id}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
